import type {
  ProgressComparisonEntry,
  ProgressComparisonEntryApiResource,
  ProgressEntry,
  ProgressEntryApiResource,
  ProgressEntryWriteDraft,
  ProgressMetricScale,
  ProgressMetricScaleApiResource,
  ProgressMetricSeries,
  ProgressMetricSeriesApiResource,
  ProgressSeriesPoint,
  ProgressSeriesPointApiResource,
} from './progressApi.types';

function mapScale(resource: ProgressMetricScaleApiResource): ProgressMetricScale {
  return {
    minimumValue: Number(resource.minimum_value),
    maximumValue: resource.maximum_value === null ? null : Number(resource.maximum_value),
    unitCode: resource.unit_code,
    higherIsBetter: resource.higher_is_better,
  };
}

function mapSeriesPoint(resource: ProgressSeriesPointApiResource): ProgressSeriesPoint {
  return {
    recordedOn: resource.recorded_on,
    value: Number(resource.value),
    ownerFeedback: resource.owner_feedback,
  };
}

export function mapApiResourceToProgressMetricSeries(
  resource: ProgressMetricSeriesApiResource
): ProgressMetricSeries {
  return {
    metricCode: resource.metric_code,
    scale: mapScale(resource.scale),
    points: resource.points.map(mapSeriesPoint),
  };
}

export function mapApiResourceToProgressComparisonEntry(
  resource: ProgressComparisonEntryApiResource
): ProgressComparisonEntry {
  return {
    metricCode: resource.metric_code,
    scale: mapScale(resource.scale),
    baselineValue: Number(resource.baseline_value),
    baselineRecordedOn: resource.baseline_recorded_on,
    latestValue: Number(resource.latest_value),
    latestRecordedOn: resource.latest_recorded_on,
    delta: Number(resource.delta),
    classification: resource.classification,
  };
}

export function mapApiResourceToProgressEntry(resource: ProgressEntryApiResource): ProgressEntry {
  return {
    id: resource.id,
    patientId: resource.patient_id,
    metricCode: resource.metric_code,
    recordedOn: resource.recorded_on,
    value: Number(resource.value),
    ownerFeedback: resource.owner_feedback,
    sessionNoteId: resource.session_note_id,
    source: resource.source,
    createdAt: resource.created_at,
    updatedAt: resource.updated_at,
  };
}

export function mapProgressEntryWriteDraftToApiPayload(
  draft: ProgressEntryWriteDraft
): Record<string, unknown> {
  return {
    recorded_on: draft.recordedOn,
    entries: draft.entries.map(function mapEntry(entry) {
      return { metric_code: entry.metricCode, value: entry.value };
    }),
    owner_feedback: draft.ownerFeedback,
    session_note_id: draft.sessionNoteId,
  };
}
